import React, { useState, useEffect } from "react";
import ApiService from "../../services/Api.service";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Alert from "../../components/Alert/Alert";
import Pagination from "../../components/Pagination/Pagination";
import StatusBadge from "../../utilities/StatusBadge";
import FilterBar from "../../components/FilterBar/FilterBar";
import Loader from "../../components/Loader/Loader";
import AuthService from "../../services/Auth.service";

export default function LogHistory({logType}) {
    const [Loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [postsPerPage, setPostsPerPage] = useState(20);
    const [headers, setHeaders] = useState([]);
    const [dropDownData, setDropDownData] = useState([]);
    const [dumpTypes, setDumpTypes] = useState([]);
    const currentDate = new Date().toISOString().split("T")[0];
    const [pagination, setPagination] = useState({
        page: 1,
        size: 20,
        total: 0,
        total_pages: 0,
    });
    const [alertValue, setAlertValue] = useState({
        show: false,
        message: "",
        variant: "success",
        position: "middle",
    });
    const [selectedRowIndex, setSelectedRowIndex] = useState(null);

    const validationSchema = yup.object().shape({
    });

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(validationSchema),
    });

    const fetchDetail = async (page = 1, size = postsPerPage, payload = null) => {
        try {
            setLoading(true);
            if (!payload) {
                if( logType =="upload"){
                    payload = {
                    subprocess_id: "",
                    start_date: "",
                    end_date: "",
                    dump_type: "audio",
                }
                }
                else{
                payload = {
                    start_date: "",
                    end_date: "",
                }
                }
                ;
            }
            let res;
            if (logType =="upload"){
            res = await ApiService.getUploadLogHistory(payload, { page, size });
            }
            else{
            res = await AuthService.getLogHistory(payload, { page, size });
            }
            if (res.status === 200 && res.data) {
                setTableData(res.data.data);
                setPagination(res.data.pagination);
                setHeaders(res.data.header);
                setSelectedRowIndex(null);
                setLoading(false);
            }
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const fetchDropdownDetail = async () => {
        try {
            const subprocessRes = await ApiService.getSubprocesses();
            if (subprocessRes.status === 200) setDropDownData(subprocessRes.data);
            let dumpTypesRes = await ApiService.getDumpTypes();
            if (dumpTypesRes.status === 200 && dumpTypesRes.data.dump_type) {
            setDumpTypes(dumpTypesRes.data.dump_type);
            }


        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchDropdownDetail();
        fetchDetail();
    }, []);

    const handelSubmit = async (data) => {
        let payload
        if (logType!= "upload"){
        payload = {
        start_date:data.start_date,
        end_date:data.end_date,
        };
        }
        else{
        payload = {
        subprocess_id:data.subprocess_id,
        start_date:data.start_date,
        end_date:data.end_date,
        dump_type:data.dump_type,
        };
        }
        fetchDetail(1, postsPerPage, payload);
    };


    const handleClearFilters = () => {
        reset({
            start_date:"",
            end_date:""
        });
        fetchDetail();
    };

    const handlePageSizeChange = (e) => {
        const newSize = Number(e.target.value);
        setPostsPerPage(newSize);
        fetchDetail(1, newSize);
        setSelectedRowIndex(null);
    };

    const mistableTh = {
        backgroundColor:"transparent",
        color: "rgba(43, 58, 103, 1)",
        fontFamily: "Nunito",
        fontSize: "12px",
        fontWeight: 700,
        lineHeight: "16px",
        letterSpacing: "0.1em",
        textAlign: "center",
    };

    const tableTdStyles = {
        fontFamily: "Nunito",
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "16px",
        letterSpacing: "0em",
        textAlign: "center",
        color: "#232122",
    };

    const filterConfigTable = [
        {
            name: "start_date",
            label: "Start Date",
            type: "date",
            placeholder: "Start Date",
            defaultValue: currentDate,

        },
        {
            name: "end_date",
            label: "End Date",
            type: "date",
            placeholder: "End Date",
            defaultValue: currentDate,
        },
    ];

    const filterConfigUploadTable = [
        {
            name: "subprocess_id",
            label: "Company",
            type: "select",
            placeholder: "Select Templete",   // 👈 default option
            options: dropDownData.map((item) => ({ label: item.name, value: item.id })),
            },

        {
            name: "dump_type",
            label: "Dump Type",
            type: "select",
            placeholder: "Select Dump Type",   // 👈 default option
            options: dumpTypes.map((item) => ({ label: item.label, value: item.value })),
            },
        {
            name: "start_date",
            label: "Start Date",
            type: "date",
            placeholder: "Start Date",
            defaultValue: currentDate,

        },
        {
            name: "end_date",
            label: "End Date",
            type: "date",
            placeholder: "End Date",
            defaultValue: currentDate,
        }, 
    ];

    return (
        <> {alertValue.show && (
            <Alert
                variant={alertValue.variant}
                message={alertValue.message}
                dismissible={true}
                timeout={2500}
                position={alertValue.position}
                onClose={() => setAlertValue({ show: false, message: "", variant: "" })}
            />
        )}
            <div className="insights-container">
                <>
                    {Loading && (
                        <div className="loader-container">
                            <Loader />
                        </div>
                    )}

                    <div className="main-contanier">
                        <FilterBar
                            control={control}
                            handleSubmit={handleSubmit}
                            onSubmit={handelSubmit}
                            onClearFilters={handleClearFilters}
                            filters={ logType =="upload" ? filterConfigUploadTable :filterConfigTable}
                            title={ logType =="upload" ?"Upload Log History":"Log History"}
                            totalCount={pagination.total || 0}
                            tableId="table-id"
                            isDownload={false}
                        />

                        <div className="table-container dailymis-table" style={{ height: "calc(100vh - 210px)" }}>
                            <table id="table-id" className="custom-table-container">
                                <thead
                                    className="table-head"
                                    style={{ position: "sticky", top: "0", zIndex: "1" }}
                                >

                                    <tr>
                                        <th style={mistableTh}>S.No</th>
                                        {headers.map((header, i) => (
                                            <th key={i} style={mistableTh}>
                                                {header.label}
                                            </th>
                                        ))}
                                    </tr>


                                </thead>

                                <tbody>
                                    {tableData.length > 0 ? (
                                        tableData.map((item, index) => (
                                            <tr key={index} style={{ cursor: "pointer" }}>
                                                <td
                                                    style={{
                                                        ...tableTdStyles,
                                                        backgroundColor:
                                                            selectedRowIndex === index ? "#f9faff" : "transparent",
                                                    }}
                                                >
                                                    {index + 1}
                                                </td>
                                                {headers.map((header, i) => (
                                                    <td
                                                        key={i}
                                                        style={{
                                                            ...tableTdStyles,
                                                            backgroundColor:
                                                                selectedRowIndex === index ? "#f9faff" : "transparent",
                                                                
                                                        }}
                                                        title={item[header.value] ?? "--"}
                                                    >
                                                        {header.value === "status" ? (
                                                            <StatusBadge status={item.status} />
                                                        ) : header.value === "disposition" ? (
                                                            <StatusBadge status={item.disposition} />
                                                        ) : (
                                                            item[header.value] ?? "--"
                                                        )}
                                                    </td>
                                                ))}
                                                

                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan={
                                                    headers.length + 1
                                                }
                                                style={tableTdStyles}
                                            >
                                                No data available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <Pagination
                            pagination={pagination}
                            postsPerPage={postsPerPage}
                            handlePageSizeChange={handlePageSizeChange}
                            fetchDetail={fetchDetail}
                        />
                    </div>

                </>
            </div>

        </>
    );
}

